import type { ReactNode } from "react";
import { Box, Tooltip } from "@mui/material";

type Props = {
  active?: boolean;
  color?: string;
  tooltip?: ReactNode;
  tooltipLabel?: string;
};

export const ApplicantStatusIndicator = ({
  active,
  color = "primary.main",
  tooltip,
  tooltipLabel,
}: Props) => (
  <Tooltip
    title={active ? tooltip || "" : ""}
    arrow
    slotProps={{
      tooltip: {
        sx: { whiteSpace: "pre-wrap", overflowWrap: "anywhere", maxWidth: 400 },
      },
    }}
  >
    <Box
      tabIndex={active && tooltip ? 0 : undefined}
      aria-label={active ? tooltipLabel : undefined}
      sx={
        active
          ? {
              width: "20px",
              height: "20px",
              borderRadius: "50%",
              backgroundColor: color,
            }
          : {
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              border: "1px solid #000A441C",
              backgroundColor: "transparent",
            }
      }
    />
  </Tooltip>
);
